import type { EstadoDaCadeiaNoPayload } from '../types/autenticacaoPublica.types';

/** Por que a página não pode afirmar autenticidade do documento. */
export type CadeiaNaoConfirmada =
  | { motivo: 'DIVERGENTE'; versao: number | null }
  | { motivo: 'NAO_VERIFICADA' };

/**
 * Decide se a página deixa de afirmar autenticidade (core#1186). Só o valor EXATO conta: o payload
 * ainda não passa por Zod (TODO(#838)), e um `"false"` ou `0` vindo torto não pode inventar aviso.
 * Chave ausente é documento sem cadeia própria ou core anterior: `null`, a página de sempre.
 *
 * @example cadeiaNaoConfirmada({ cadeiaIntegra: false, cadeiaQuebradaNaVersao: 3 })
 * // { motivo: 'DIVERGENTE', versao: 3 }
 */
export function cadeiaNaoConfirmada(data: EstadoDaCadeiaNoPayload): CadeiaNaoConfirmada | null {
  if (data.cadeiaIntegra === false) {
    const versao = data.cadeiaQuebradaNaVersao;
    return {
      motivo: 'DIVERGENTE',
      versao: typeof versao === 'number' && Number.isInteger(versao) ? versao : null,
    };
  }
  if (data.cadeiaIntegra === null) return { motivo: 'NAO_VERIFICADA' };
  return null;
}
